import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { mobfeedMedia } from 'lib/api/mobfeed';
import { withRouter } from 'react-router-dom';

import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';
import { setPortal } from 'modules/portal';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';
import FilterCollection from 'components/organisms/FilterCollection';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { useTheme } from '@material-ui/core/styles';

const MediaStatistics = ({ location }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { portal } = useSelector(({ portal }) => ({ portal: portal }));

  const initList = {
    mfSupplyTpCode: [
      { label: '전체', value: 'all' },
      { label: '한줄', value: '01' },
      { label: '인앱(포탈)', value: '02' },
    ],
  };

  let initParams = {
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    mfSupplyTpCode: 'all',
    pltfomTpCode: 'all',
  };
  //todo [popup-params] 모비피드 - 일자별통계 : sDate, eDate
  const convertKeys = ['sDate', 'eDate', 'isPop'];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );

  initParams = {
    ...initParams,
    ...newInitParams,
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handlePortalUrl = useCallback(
    (url) => {
      let newPortal = portal.portal;
      let popIndex = newPortal.length;
      newPortal[popIndex] = {
        url: url,
        cnt: popIndex,
      };
      dispatch(setPortal(newPortal));
    },
    [portal, dispatch]
  );

  const customized = {
    MEDIA_NAME: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'MEDIA_NAME').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const itemObj = getHeadObj(headsMap, 'MEDIA_NAME');
        const { isPop } = params;
        const convertKeys = [
          'sDate',
          'eDate',
          'pltfomTpCode',
          'mfSupplyTpCode',
        ];
        const addParams = dataConverter(params, convertKeys, 'string');
        const showWindowUrl =
          '/report/mobfeed/daily?isPop=1&mediaId=' +
          rowObj['MEDIA_ID'] +
          addParams;

        let resultComponent;
        resultComponent = (
          <>
            {rowObj['MEDIA_NAME'] !== 'total' && parseInt(isPop) !== 1 ? (
              <>
                <IconAreaWrap
                  text={makeRowColumn(
                    rowObj['MEDIA_NAME'],
                    itemObj.type,
                    itemObj.format
                  )}
                  icon={rowObj['MEDIA_NAME'] !== 'total' && 'faExternalLink'}
                  toolTipTitle={t('해당 날짜의 일자별 통계')}
                  onClick={(e) => handlePortalUrl(showWindowUrl)}
                />
              </>
            ) : (
              <>total</>
            )}
          </>
        );

        return resultComponent;
      },
    },
    NEWS_CNT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('수집기사수')}
                tooltipTitle={t('모비피드 뉴스제공 언론사 수집기사수')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
    },
    PAGE_VIEW: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('PV')}
                tooltipTitle={t('페이지뷰')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
    },
    NEWS_GR_CNT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('기사 구좌노출수')}
                tooltipTitle={t('기사 구좌별 노출수')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'NEWS_GR_CNT');
        return (
          <p style={{ color: theme.palette.common.blue }}>
            {makeRowColumn(rowObj['NEWS_GR_CNT'], valObj.type, valObj.format)}
          </p>
        );
      },
    },
    NEWS_TOT_EPRS_CNT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('기사 총노출수')}
                tooltipTitle={t('모비피드 뉴스제공 언론사 수집 총기사수')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'NEWS_TOT_EPRS_CNT');
        return (
          <p style={{ color: theme.palette.common.blue }}>
            {makeRowColumn(
              rowObj['NEWS_TOT_EPRS_CNT'],
              valObj.type,
              valObj.format
            )}
          </p>
        );
      },
    },

    NEWS_CLICK_CNT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('기사 클릭수')}
                tooltipTitle={t('클릭된 기사수')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
    },
    NEWS_CLICK_RATE: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('기사 클릭률')}
                tooltipTitle={t('(기사클릭수/기사구좌노촐수)*100')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
      makeBody: (rowObj, headsMap) => {
        const valObj = getHeadObj(headsMap, 'NEWS_CLICK_RATE');
        return (
          <p style={{ color: theme.palette.common.blue }}>
            {makeRowColumn(
              rowObj['NEWS_CLICK_RATE'],
              valObj.type,
              valObj.format
            )}
          </p>
        );
      },
    },
    NEWS_INF_CNT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('유입수')}
                tooltipTitle={t('타입별 유입된 사용자수')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
      headStyle: {
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderRight: '1px solid #e5e8eb',
      },
    },
    OUT_LINK_CNT: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={t('아웃링크수')}
                tooltipTitle={t('언론사 사이트로 직접 유입된수')}
                iconType="fainfoCircle"
              />
            </>
          ),
        };
      },
    },

    MEDIA_ID: {
      merged: true,
    },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
        />
        <FilterCollection
          label={t('뉴스제공방식')}
          name="mfSupplyTpCode"
          params={params}
          value={params.mfSupplyTpCode}
          type="select"
          list={initList.mfSupplyTpCode}
          callBack={getParam}
          labelKey="label"
          valueKey={'value'}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={mobfeedMedia}
        params={params}
        getParam={getParam}
        customized={customized}
      />
    </>
  );
};

export default withRouter(MediaStatistics);
